module.exports = __webpack_public_path__ + "img/_013.c6cb075b.png";